import { render, staticRenderFns } from "./RegulationsSelection.vue?vue&type=template&id=45c86f2f"
import script from "./RegulationsSelection.vue?vue&type=script&lang=js"
export * from "./RegulationsSelection.vue?vue&type=script&lang=js"
import style0 from "./RegulationsSelection.vue?vue&type=style&index=0&id=45c86f2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports